import React, { useState, useEffect } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";

interface CompanyNewsWidgetProps {
  id: string;
  title: string;
  isDemo?: boolean;
}

interface NewsItem {
  id: string;
  title: string;
  content: string;
  date: string;
  author: string;
}

const CompanyNewsWidget: React.FC<CompanyNewsWidgetProps> = ({ title, isDemo = false }) => {
  const [news, setNews] = useState<NewsItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isDemo) {
      // Demo data
      setNews([
        {
          id: "1",
          title: "Nieuwe medewerker welkom",
          content: "We heten een nieuwe collega welkom in ons team!",
          date: new Date().toISOString(),
          author: "HR Team",
        },
        {
          id: "2",
          title: "Teamuitje gepland",
          content: "Volgende maand gaan we met het team een dagje uit.",
          date: new Date().toISOString(),
          author: "Team Lead",
        },
        {
          id: "3",
          title: "Nieuwe office opening",
          content: "We openen een nieuw kantoor in Amsterdam.",
          date: new Date().toISOString(),
          author: "Management",
        },
      ]);
    } else {
      // Fetch company news from API
      fetch(`${import.meta.env.VITE_API_URL}/api/news`)
        .then((response) => response.json())
        .then((data) => {
          setNews(data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching company news:", error);
          setLoading(false);
        });
    }
    setLoading(false);
  }, [isDemo]);

  if (loading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="animate-pulse space-y-4">
            <div className="h-4 bg-muted rounded w-3/4"></div>
            <div className="h-4 bg-muted rounded w-1/2"></div>
            <div className="h-4 bg-muted rounded w-2/3"></div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {news.map((item) => (
            <div key={item.id} className="space-y-2">
              <h3 className="text-sm font-medium">{item.title}</h3>
              <p className="text-sm text-muted-foreground">{item.content}</p>
              <div className="flex justify-between text-xs text-muted-foreground">
                <span>{item.author}</span>
                <span>{new Date(item.date).toLocaleDateString()}</span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default CompanyNewsWidget; 